export enum SearchType {
    Hybrid = "Hybrid", // Do a phrase search, then filter those results to ONLY show those that match the specified tag
    Phrase = "Phrase", // Find any topic that contains the phrase provided in it's title, one of it's tags, or one of it's sub-topic titles
    Tag = "Tag", // Find topics with a specific tag
}